var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-table", {
    ref: "multipleTable",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      stripe: "",
      "tooltip-effect": "dark"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "ID",
      prop: "ID",
      width: "60"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "流程名称",
      prop: "workflowProcess.label",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "发起人",
      prop: "promoter.nickName",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "节点日期",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "业务代码",
      prop: "businessType",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "当前节点",
      prop: "workflowNode.label",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "流程状态",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(" " + _vm._s(scope.row.isActive ? "进行中" : "已结束") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "详细介绍",
      prop: "workflowProcess.description",
      "min-width": "200"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "按钮组"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          on: {
            click: function click($event) {
              return _vm.view(scope.row);
            }
          }
        }, [_vm._v("查看")])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };